// frontend/src/components/DistBars.js
//
// Megoszlás sávokkal (címke · sáv · darab (%)). Korábban a Narrációk lap saját
//   `Dist` komponense volt („Nyitó stílus", „Wiki forrás"); közös komponens lett,
//   mert a Minőség lap „Prompt út" kártyája ugyanezt rajzolja.
import React from 'react';

const card = { background: '#1a1d27', border: '1px solid #2a2e3a', borderRadius: 12, padding: 16 };
const title = { fontSize: 13, color: '#8b8fa3', fontWeight: 600, marginBottom: 8, textTransform: 'uppercase', letterSpacing: 0.5 };

// dist:      { kulcs: darab }
// colors:    { kulcs: szín }
// total:     a százalék nevezője (alapból a darabok összege)
// labelOf:   kulcs → megjelenített címke
// emptyText: ha nincs adat — megadva a kártya kiírja, nélküle nem rajzol semmit
// order:     rögzített kulcssorrend; nélküle darabszám szerint csökkenő
// showZero:  a 0 darabos sorok is látszódjanak (pl. „rövid 0" maga is információ)
export default function DistBars({ label, dist, colors = {}, total, labelOf = (k) => k, emptyText, order, showZero, style }) {
  let entries = Object.entries(dist || {}).filter(([, v]) => typeof v === 'number' && (showZero ? v >= 0 : v > 0));
  entries = order
    ? entries.sort((a, b) => order.indexOf(a[0]) - order.indexOf(b[0]))
    : entries.sort((a, b) => b[1] - a[1]);
  const sum = total != null ? total : entries.reduce((a, [, v]) => a + v, 0);
  if (!entries.length && !emptyText) return null;
  const pct = (v) => (sum ? Math.round((v / sum) * 100) : 0);
  return (
    <div style={{ ...card, flex: 1, minWidth: 220, ...style }}>
      <div style={title}>{label}</div>
      {!entries.length ? (
        <div style={{ color: '#8b8fa3', fontSize: 12 }}>{emptyText}</div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
          {entries.map(([k, v]) => (
            <div key={k} style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 12 }}>
              <span style={{ width: 70, color: colors[k] || '#e4e6eb', fontWeight: 600 }}>{labelOf(k)}</span>
              <div style={{ flex: 1, height: 8, background: '#0a0d14', borderRadius: 4, overflow: 'hidden' }}>
                <div style={{ width: `${pct(v)}%`, height: '100%', background: colors[k] || '#00d4ff' }} />
              </div>
              <span style={{ color: '#8b8fa3', width: 70, textAlign: 'right' }}>{v} ({pct(v)}%)</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
